import type { BeginCheckoutEventProps } from './buildBeginCheckoutEvent';

let pendingBeginCheckout: BeginCheckoutEventProps | null = null;

export const setPendingBeginCheckout = (props: BeginCheckoutEventProps): void => {
  pendingBeginCheckout = props;
};

export const takePendingBeginCheckout = (): BeginCheckoutEventProps | null => {
  const props = pendingBeginCheckout;
  pendingBeginCheckout = null;
  return props;
};
